import React from "react";
import { useAuth0 } from "@auth0/auth0-react";

const LoginButtonComponent: React.FC = () => {
  const { loginWithRedirect } = useAuth0();

  const handleLogin = () => {
    loginWithRedirect({
      authorizationParams: {
        audience: "https://fxer.ai/api",
        scope: "read:all",
      },
    });
  };

  return (
    <button
      onClick={handleLogin}
      style={{
        backgroundColor: "#131E3A", // White background
        color: "#FFFFFF", // Dark blue text
        border: "none",
        padding: "10px 20px",
        fontSize: "16px",
        borderRadius: "5px",
        cursor: "pointer",
        transition: "background-color 0.3s ease",
      }}
    >
      Log In
    </button>
  );
};

export default LoginButtonComponent;
